import styled from '@emotion/styled';

const Container = styled.div`
  font-family: var(--font-Pretendard);
  width: 100vw;
`;

const StyledButton = styled.button`
  padding: 0;
  > svg {
    vertical-align: middle;
  }
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px 20px 0 20px;
`;

export { Container, StyledButton, SubContainer };
